/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Condition,
  Condition$inboundSchema,
  Condition$Outbound,
  Condition$outboundSchema,
} from "./condition.js";

/**
 * Configuration that is specific to a Linear Gauge.
 */
export type LinearGaugeConig = {
  /**
   * Defines a single condition that compares a source value against a target value.
   */
  isTrim?: Condition | undefined;
};

/** @internal */
export const LinearGaugeConig$inboundSchema: z.ZodType<
  LinearGaugeConig,
  z.ZodTypeDef,
  unknown
> = z.object({
  is_trim: types.optional(Condition$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "is_trim": "isTrim",
  });
});
/** @internal */
export type LinearGaugeConig$Outbound = {
  is_trim?: Condition$Outbound | undefined;
};

/** @internal */
export const LinearGaugeConig$outboundSchema: z.ZodType<
  LinearGaugeConig$Outbound,
  z.ZodTypeDef,
  LinearGaugeConig
> = z.object({
  isTrim: Condition$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    isTrim: "is_trim",
  });
});

export function linearGaugeConigToJSON(
  linearGaugeConig: LinearGaugeConig,
): string {
  return JSON.stringify(
    LinearGaugeConig$outboundSchema.parse(linearGaugeConig),
  );
}
export function linearGaugeConigFromJSON(
  jsonString: string,
): SafeParseResult<LinearGaugeConig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LinearGaugeConig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LinearGaugeConig' from JSON`,
  );
}
